export default "__VITE_ASSET__e3b32a1a__"